import React, { useState, useEffect } from 'react';
import '../styles/SuccessModal.css';

const SuccessModal = ({ 
    message, 
    onClose, 
    icon, 
    iconColor, 
    classSet = "",
    autoCloseDuration = 3000, // Duration in milliseconds (default: 3 seconds)
    showProgressBar = true
}) => {
    const [progress, setProgress] = useState(100);
    const [isPaused, setIsPaused] = useState(false);

    useEffect(() => {
        if (!autoCloseDuration) return;

        let startTime = Date.now();
        let animationFrameId;

        const updateProgress = () => {
            if (isPaused) {
                animationFrameId = requestAnimationFrame(updateProgress);
                return;
            }

            const elapsed = Date.now() - startTime;
            const remaining = Math.max(0, autoCloseDuration - elapsed);
            const newProgress = (remaining / autoCloseDuration) * 100;
            
            setProgress(newProgress);

            if (remaining > 0) {
                animationFrameId = requestAnimationFrame(updateProgress);
            } else {
                onClose();
            }
        };

        animationFrameId = requestAnimationFrame(updateProgress);

        return () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        };
    }, [autoCloseDuration, onClose, isPaused]);

    // Handle mouse enter/pause functionality
    const handleMouseEnter = () => {
        if (autoCloseDuration) {
            setIsPaused(true);
        }
    };

    const handleMouseLeave = () => {
        if (autoCloseDuration) {
            setIsPaused(false);
        }
    };

    return (
        <div className={`modal-overlay ${classSet}`}>
            <div 
                className="modal-content"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {showProgressBar && autoCloseDuration && (
                    <div className="progress-bar-container">
                        <div 
                            className="progress-bar-fill"
                            style={{ width: `${progress}%` }}
                        />
                    </div>
                )}
                <i className={`fa-regular fa-circle-${icon} font-${iconColor} modal-icon`}></i>
                <p className="modal-message male-female-stat">{message}</p>
                <button className="modal-button" onClick={onClose}>OK</button>
            </div>
        </div>
    );
};

export default SuccessModal;